import config from '../../config';
import CookieHelper from './CookieHelper';
import FetchHelper from './OldFetchHelper';
import LocalStorageHelper from './OldLocalStorageHelper';
import OldErrorHandlerHelper from './OldErrorHandlerHelper';

class CustomerHelper {
  async checkTokenValidity() {
    if(!this.getLoggedInState()) {
      return false;
    }
    const token = CookieHelper.getAuthToken();
    const fetchConfig = {
      path: `${config.api.paths.customers.basepath}${config.api.paths.customers.paths.token}/${token}`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    // we got a token but its invalid - clear all
    if(!fetchResult.success) {
      LocalStorageHelper.removeAll();
      CookieHelper.removeAll();
      window.location.reload();
    }

    return fetchResult.success;
  }

  async getPersonalInfo(useCache = true) {
    if(!this.getLoggedInState()) {
      return false;
    }

    if(useCache) {
      const user = LocalStorageHelper.getPersonalInfo();
      if(user && LocalStorageHelper.isLocalStorageFilledCorrectly()) {
        return user;
      }
    }

    const fetchConfig = {
      path: `${config.api.paths.customers.basepath}`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    if(fetchResult.success) {
      LocalStorageHelper.setPersonalInfo(fetchResult.data);
      return fetchResult.data;
    }
    OldErrorHandlerHelper.handleError(fetchResult, { logToConsole: true });
    return false;
  }

  /**
   * update personalInfo in localStorage
   * @param force {boolean}
   * @return {object}
   */
  async getExpandedPersonalInfo(force = false) {
    let personalInfo = LocalStorageHelper.getPersonalInfo();
    if(personalInfo === null || !personalInfo.account || !personalInfo.account.customerNumber) {
      return false;
    }
    if(personalInfo.expandedPersonalInfo && !force) {
      return {
        data: personalInfo,
        success: true,
      };
    }
    const fetchConfig = {
      path: `${config.api.paths.customers.basepath}?customerNumber=${personalInfo.account.customerNumber}`,
    };
    const fetchResult = await FetchHelper.get(fetchConfig);
    if(!fetchResult.success) {
      return fetchResult;
    }
    const { data } = fetchResult;
    personalInfo = LocalStorageHelper.upgradePersonalInfo(data);
    return {
      data: personalInfo,
      success: true,
    };
  }

  getLoggedInState() {
    if(!CookieHelper.getAuthToken()) return false;

    return CookieHelper.getAuthToken();
  }

  calculateAge(birthday) { // birthday is a date
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  getPartnerStatus() {
    const personalInfo = LocalStorageHelper.getPersonalInfo();
    if(personalInfo) return personalInfo.isPartner;
    return false;
  }

  logout() {
    if(window.sentryInitialized) {
      Sentry.configureScope(scope => scope.setUser(null));
      Sentry.setTag(`authenticated`, `false`); // Sentry decides to parse a bool string to bool while a bool is parsed to a string
      Sentry.setTag(`role`, undefined);
    }

    CookieHelper.removeAll();
    LocalStorageHelper.removeAll();
  }

  isUserInTestgroup() {
    const personalInfo = LocalStorageHelper.getPersonalInfo();
    if(!personalInfo || !personalInfo.account || !personalInfo.account.customerNumber || !config || !config.testgroup) {
      return false;
    }
    return (config.testgroup.indexOf(Number(personalInfo.account.customerNumber)) !== -1);
  }

  setABTestForTestGroup(expirationDate) {
    const dateRegx = /^\d{4}([./-])\d{2}\1\d{2}$/;
    if(this.isUserInTestgroup() && expirationDate.match(dateRegx)) {
      const versionCookie = `rin-version`;
      const expiration = new Date(expirationDate);
      if(CookieHelper.getCookie(versionCookie)) {
        CookieHelper.removeCookie(versionCookie);
      }
      CookieHelper.setCookie(versionCookie, `b-20210406`, { expires: expiration.toUTCString() });
    }
  }
}

export default new CustomerHelper();
